import Router from 'next/router';
import { useSnapshot } from 'valtio';
import { enumChecker } from '@soundxyz/utils/const';
import { SEARCH_TAB_CHOICES } from '@components/Explore/schema';
import {
  setActiveTab,
  setDefaultSort,
  setExploreType,
} from '@components/Explore/useSearchPageStore';
import { ParamsStore } from '@context/params';
import { ReleaseStatus } from '@graphql/reactQuery';
import { setSearchPageText } from '@hooks/search/useSearchInputNew';
import { searchPageStoreState } from './store';

export function getSearchPageResults({
  inputText,
  useRouter = false,
}: {
  inputText: string;
  useRouter: boolean;
}) {
  const tab = inputText === '' ? SEARCH_TAB_CHOICES.SOUNDS : SEARCH_TAB_CHOICES.ALL;

  if (useRouter) {
    Router.push(`/search`).then(() => {
      ParamsStore.tab = tab;
      ParamsStore.q = inputText;
      setActiveTab({ activeTab: tab });
      setSearchPageText({ text: inputText });
      setExploreType({ type: null });
      setDefaultSort({ type: tab });
    });
  } else {
    ParamsStore.tab = tab;
    ParamsStore.q = inputText;
    setActiveTab({ activeTab: tab });
    setSearchPageText({ text: inputText });
    setExploreType({ type: null });
    setDefaultSort({ type: tab });
  }
}

export function useCurrentSearchTabsAndFilters() {
  const { activeTab, exploreType } = useSnapshot(searchPageStoreState);

  const isArtistTab = activeTab === SEARCH_TAB_CHOICES.ARTISTS;
  const isSoundsTab = activeTab === SEARCH_TAB_CHOICES.SOUNDS;
  const isPlaylistsTab = activeTab === SEARCH_TAB_CHOICES.PLAYLISTS;
  const isCollectorsTab = activeTab === SEARCH_TAB_CHOICES.COLLECTORS;

  const showAvailabilityFilter = exploreType ? exploreType === 'sounds' : isSoundsTab;
  const showLocationFilter = exploreType
    ? exploreType === 'sounds' || exploreType === 'artists' || exploreType === 'collectors'
    : isSoundsTab || isArtistTab || isCollectorsTab;
  const showGenreFilter = exploreType
    ? exploreType === 'sounds' || exploreType === 'artists' || exploreType === 'playlists'
    : isSoundsTab || isArtistTab || isPlaylistsTab;

  return {
    isArtistTab,
    isSoundsTab,
    isPlaylistsTab,
    isCollectorsTab,
    showAvailabilityFilter,
    showLocationFilter,
    showGenreFilter,
  };
}

export const resetFilters = () => {
  ParamsStore.search_location_label = null;
  ParamsStore.search_location_place_id = null;
  ParamsStore.genre = null;
  ParamsStore.search_availability = null;
};

export const resetParams = () => {
  ParamsStore.q = null;
  ParamsStore.tab = null;
};

export const isAvailabilityType = enumChecker(ReleaseStatus);

export const isVolumeSort = ({ sortType }: { sortType: string }) => {
  return sortType === 'Volume (High to Low)' || sortType === 'Volume';
};

export const isArtistsBackedSort = ({ sortType }: { sortType: string }) => {
  return sortType === 'Artists Backed (High to Low)' || sortType === 'Artists Backed';
};

export const clearSortParams = () => {
  ParamsStore.total_minted = null;
  ParamsStore.created_at = null;
  ParamsStore.mint_start_time = null;
  ParamsStore.num_referral_purchases = null;
  ParamsStore.total_volume = null;
  ParamsStore.artists_backed = null;
  ParamsStore.nfts_count = null;
  ParamsStore.first_nft_collected_date = null;
};
